var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2189_3828)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2189_3828)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2189_3828",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 26,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07079 26.2349V0.773424H26.5322V26.2349H1.07079Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0498268
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2189_3828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5571 13.6469H1.04586C1.04586 20.6624 6.78595 26.3496 13.8015 26.3496C20.817 26.3496 26.5571 20.6624 26.5571 13.6469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5571 13.6469H1.04586C1.04586 20.6624 6.78595 26.3496 13.8015 26.3496C20.817 26.3496 26.5571 20.6624 26.5571 13.6469Z",
    fill: "url(#paint0_linear_2189_3828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71535 13.6361C7.71535 20.6516 10.3899 26.3496 13.7908 26.3496C17.1918 26.3496 19.8876 20.6277 19.8876 13.6122",
    stroke: "white",
    strokeWidth: 0.529281,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9646 21.2715C21.6471 19.536 17.9574 18.4134 13.8015 18.4134C9.64563 18.4134 5.95592 19.536 3.63841 21.2715",
    stroke: "white",
    strokeWidth: 0.529281,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4197 4.45613C11.4197 5.77155 12.486 6.83789 13.8014 6.83789C15.1169 6.83789 16.1832 5.77155 16.1832 4.45613C16.1832 3.14071 15.1169 2.07438 13.8014 2.07438C12.486 2.07438 11.4197 3.14071 11.4197 4.45613Z",
    fill: "url(#paint1_linear_2189_3828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98231 13.6484V11.6737C7.98231 9.49255 10.5849 7.72434 13.7953 7.72434C17.0057 7.72434 19.6083 9.49255 19.6083 11.6737V13.6484",
    fill: "url(#paint2_linear_2189_3828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83978 4.91512C1.83978 6.23054 2.95904 7.29688 4.27446 7.29688C5.58988 7.29688 6.65622 6.23054 6.65622 4.91512C6.65622 3.5997 5.58988 2.53336 4.27446 2.53336C2.95904 2.53336 1.83978 3.5997 1.83978 4.91512Z",
    fill: "url(#paint3_linear_2189_3828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04585 13.6484V12.0606C1.04585 10.3067 2.52058 8.88492 4.27446 8.88492C6.02833 8.88492 7.45013 10.3067 7.45013 12.0606V13.6484",
    fill: "url(#paint4_linear_2189_3828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9468 4.91512C20.9468 6.23054 22.0131 7.29688 23.3285 7.29688C24.644 7.29688 25.7103 6.23054 25.7103 4.91512C25.7103 3.5997 24.644 2.53336 23.3285 2.53336C22.0131 2.53336 20.9468 3.5997 20.9468 4.91512Z",
    fill: "url(#paint5_linear_2189_3828)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1528 13.6484V12.0606C20.1528 10.3067 21.5747 8.88492 23.3285 8.88492C25.0824 8.88492 26.5571 10.3067 26.5571 12.0606V13.6484",
    fill: "url(#paint6_linear_2189_3828)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2189_3828",
    x1: 13.8015,
    y1: 26.3496,
    x2: 13.8015,
    y2: 13.6469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2189_3828",
    x1: 13.8014,
    y1: 6.83789,
    x2: 13.8014,
    y2: 2.07438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2189_3828",
    x1: 7.72465,
    y1: 8.44533,
    x2: 10.2559,
    y2: 14.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2189_3828",
    x1: 4.248,
    y1: 7.29688,
    x2: 4.248,
    y2: 2.53336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2189_3828",
    x1: 0.903916,
    y1: 9.46467,
    x2: 3.44902,
    y2: 13.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2189_3828",
    x1: 23.3285,
    y1: 7.29688,
    x2: 23.3285,
    y2: 2.53336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2189_3828",
    x1: 20.0109,
    y1: 9.46467,
    x2: 22.556,
    y2: 13.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3661FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527DEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2189_3828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 27,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2189_3828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7159,
    height: 25.6136,
    fill: "white",
    transform: "matrix(-1 0 0 1 26.6594 0.746094)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientIcon);
export default __webpack_public_path__ + "static/media/clientIcon.5f565f44a8b8034411536321d3082840.svg";
export { ForwardRef as ReactComponent };